// extracted by mini-css-extract-plugin
export default {"defaultChatContainer":"DefaultChat_defaultChatContainer__rBye7"};